module.exports = __webpack_public_path__ + "static/img/imagehotspotter.com.fc5272b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/imagehotspotter.com.jpg
// module id = 35
// module chunks = 1